/* eslint-disable id-denylist */
import * as yup from 'yup'
import { t } from 'translations'

// Messages are functions so they are translated when validation runs, not when this module loads.
yup.setLocale({
    mixed: {
        default: () => t('common.validation.invalidField'),
        required: () => t('common.validation.required'),
    },
    number: {
        min: ({ min }) => t('common.validation.numberMin', { min }),
        max: ({ max }) => t('common.validation.numberMax', { max }),
    },
    string: {
        email: () => t('common.validation.email'),
        max: ({ max }) => t('common.validation.stringMax', { max }),
        min: ({ min }) => t('common.validation.stringMin', { min }),
    },
    array: {
        max: ({ max }) => t('common.validation.arrayMax', { max }),
        min: ({ min }) => t('common.validation.arrayMin', { min }),
    },
})

yup.addMethod(yup.object, 'uniqueProperty', function (propertyName: string, message?: string) {
    return this.test('unique', () => message ?? t('common.validation.unique'), function (value: any) {
        if (!value || !value[propertyName]) {
            return true
        }

        const { path } = this
        const options = [...this.parent]
        const currentIndex = options.indexOf(value)

        const subOptions = options.slice(0, currentIndex)

        if (subOptions.some((option) => option[propertyName] === value[propertyName])) {
            throw this.createError({
                path: `${path}.${propertyName}`,
                message: message ?? t('common.validation.unique'),
            })
        }

        return true
    })
})
